import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = ["packageWrapper", "addOnWrapper", "extraWrapper", "backdropWrapper", "lookupType", "staffWrapper", "appointmentWrapper"]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const lookupType = this.lookupTypeTargets.find(input => input.checked).value
    if(lookupType === "Package") {
      showTarget(this.packageWrapperTarget)
      hideTarget(this.addOnWrapperTarget)
      hideTarget(this.extraWrapperTarget)
      hideTarget(this.backdropWrapperTarget)
      if(this.hasStaffWrapperTarget) {
        hideTarget(this.staffWrapperTarget)
      }
      hideTarget(this.appointmentWrapperTarget)

    }
    else if(lookupType === "Add On") {
      hideTarget(this.packageWrapperTarget)
      showTarget(this.addOnWrapperTarget)
      hideTarget(this.extraWrapperTarget)
      hideTarget(this.backdropWrapperTarget)
      if(this.hasStaffWrapperTarget) {
        hideTarget(this.staffWrapperTarget)
      }
      hideTarget(this.appointmentWrapperTarget)
    }
    else if(lookupType === "Extra") {
      hideTarget(this.packageWrapperTarget)
      hideTarget(this.addOnWrapperTarget)
      showTarget(this.extraWrapperTarget)
      hideTarget(this.backdropWrapperTarget)
      if(this.hasStaffWrapperTarget) {
        hideTarget(this.staffWrapperTarget)
      }
      hideTarget(this.appointmentWrapperTarget)
    }
    else if(lookupType === "Staff") {
      hideTarget(this.packageWrapperTarget)
      hideTarget(this.addOnWrapperTarget)
      hideTarget(this.extraWrapperTarget)
      hideTarget(this.backdropWrapperTarget)
      if(this.hasStaffWrapperTarget) {
        showTarget(this.staffWrapperTarget)
      }
      hideTarget(this.appointmentWrapperTarget)
    }
    else if(lookupType === "Appointment") {
      hideTarget(this.packageWrapperTarget)
      hideTarget(this.addOnWrapperTarget)
      hideTarget(this.extraWrapperTarget)
      hideTarget(this.backdropWrapperTarget)
      if(this.hasStaffWrapperTarget) {
        hideTarget(this.staffWrapperTarget)
      }
      showTarget(this.appointmentWrapperTarget)
    }
    else if(lookupType === "Backdrop") {
      hideTarget(this.packageWrapperTarget)
      hideTarget(this.addOnWrapperTarget)
      hideTarget(this.extraWrapperTarget)
      showTarget(this.backdropWrapperTarget)
      if(this.hasStaffWrapperTarget) {
        hideTarget(this.staffWrapperTarget)
      }
      hideTarget(this.appointmentWrapperTarget)
    }
  }
}
